<template>
    <div>
        <div class="mobile_head">
            <div class="mobile_head_user" @click="handleClickUser">
                <img
                    :src="
                        userInfo.user && userInfo.user.avatar
                            ? userInfo.user.avatar
                            : 'https://download.hecoos.com/enlightv/2024-42/1a3b607fe54205013ac90744ec5405bd.jpg'
                    "
                    alt=""
                />
                <span v-text="userInfo && userInfo.user ? userInfo.user.name : ''"></span>
            </div>
            <div class="mobile_head_operate" v-if="userInfo && userInfo.user &&  userInfo.user.company_id">
                <span><i class="iconfont icon-sousuo"></i></span>

                <van-popover v-model="headOperatePopoverShow" trigger="click" placement="bottom-end">
                    <ul class="head_operate_popover_list">
                        <li v-for="item in headOperateActionsList" @click="handleClickHeadOperate(item)">
                            <i :class="item.icon"></i> <span v-text="item.text"></span>
                        </li>
                    </ul>
                    <template #reference>
                        <span><i class="iconfont icon-a-tianjiamiaobian"></i></span>
                    </template>
                </van-popover>
            </div>
            <van-popup
                :style="{ width: '88%', height: '100%' }"
                position="left"
                round
                v-cloak
                v-model:show="userPopupShow"
            >
                <div class="head_user_popup">
                    <div class="head_user_popup_list">
                        <ul>
                            <li @click="handleClickRouterName('mobilePersonalDetail')">
                                <img
                                    :src="
                                        userInfo.user && userInfo.user.avatar
                                            ? userInfo.user.avatar
                                            : 'https://download.hecoos.com/enlightv/2024-42/1a3b607fe54205013ac90744ec5405bd.jpg'
                                    "
                                    alt=""
                                />
                                <span v-text="userInfo && userInfo.user ? userInfo.user.name : ''"></span>
                                <van-icon name="arrow" />
                            </li>
                            <li @click="handleClickRouterName('')">
                                <i class="iconfont icon-bangzhuzhongxin"></i>
                                <span>帮助中心</span>
                                <van-icon name="arrow" />
                            </li>
                            <li @click="handleClickRouterName('')">
                                <i class="iconfont icon-banbenlishi"></i>
                                <span>版本历史</span>
                                <van-icon name="arrow" />
                            </li>
                            <li
                                v-if="userInfo.company && userInfo.company.length > 0"
                                @click="handleClickRouterName('mobileCompany')"
                            >
                                <i class="iconfont icon-bangzhuzhongxin"></i>
                                <span v-text="userInfo.user.company_name ? userInfo.user.company_name : '切换公司'">公司名称</span>
                                <van-icon name="arrow" />
                            </li>
                        </ul>
                    </div>
                    <div class="head_user_popup_exit" @click="handleClickExit">
                        <i class="iconfont icon-tuichudenglu"></i>退出登录
                    </div>
                </div>
            </van-popup>
        </div>
    </div>
</template>

<script>
import { Logout } from "@/api/index";
import { mapState } from "vuex";
import { Dialog } from "vant";
export default {
    name: "mobileHead",
    data() {
        return {
            headOperatePopoverShow: false,
            headOperateActionsList: [
                { text: "扫一扫", icon: "iconfont icon-saoyisao" },
                { text: "添加审批", icon: "iconfont icon-shenpi_weixuanzhong" },
            ],
            userPopupShow: false,
        };
    },
    computed: {
        ...mapState(["userInfo"]),
    },
    created() {
        console.log(this.userInfo);
    },
    methods: {
        handleClickHeadOperate(item) {
            this.headOperatePopoverShow = false;
        },

        handleClickUser() {
            this.userPopupShow = true;
        },

        handleClickRouterName(name) {
            if (!name) {
                return false;
            }
            this.$nextTick(() => {
                this.$router.push({
                    name: name,
                    query: {},
                });
            });
        },
        // 退出登录
        handleClickExit() {
            Dialog.confirm({
                title: "退出登录",
                message: "你确定要退出登录吗？",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
            })
                .then(() => {
                    Logout({}).then((res) => {
                        this.$store.dispatch("clearUserInfo");
                        this.dialogLoginOutVisible = false;
                        const path = this.$route.fullPath;
                        this.$router.push(`/login${path === "/" ? "" : `?redirect=${path}`}`);
                    });
                })
                .catch(() => {
                    // on cancel
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.mobile_head {
    display: flex;
    width: 100%;
    background: #fff;
    height: 44px;
    padding: 10px 16px;
    box-sizing: border-box;
    justify-content: space-between;
    //position: fixed;
    //left: 0;
    //top: 0;
    //z-index: 1000;
    .mobile_head_user {
        font-size: 0;
        display: flex;
        align-items: center;
        img {
            width: 24px;
            min-width: 24px;
            height: 24px;
            border-radius: 50%;
        }
        span {
            flex: 1;
            font-size: 14px;
            color: rgba(51, 51, 51, 1);
            font-weight: bold;
            display: inline-block;
            margin-left: 8px;
        }
    }
    .mobile_head_operate {
        display: flex;
        gap: 12px;
        span {
            width: 24px;
            height: 24px;
            border-radius: 4px;
            line-height: 24px;
            font-size: 0;
            text-align: center;
            &:active {
                background: rgba(0, 0, 0, 0.04);
            }
            i {
                vertical-align: middle;
                color: rgba(51, 51, 51, 1);
                font-size: 16px;
            }
        }
    }
}
.head_operate_popover_list {
    width: 100%;
    padding: 4px 0;
    li {
        padding: 0 12px;
        line-height: 38px;
        box-sizing: border-box;
        i {
            color: rgba(102, 102, 102, 1);
            font-size: 14px;
        }
        span {
            color: rgba(51, 51, 51, 1);
            margin-left: 8px;
            font-size: 14px;
        }
        &:active {
            background: rgba(0, 0, 0, 0.04);
        }
    }
}
.head_user_popup {
    width: 100%;
    height: 100vh;
    padding: 16px 16px 60px 16px;
    box-sizing: border-box;
    position: relative;
    .head_user_popup_list {
        width: 100%;
        ul {
            width: 100%;
            li {
                width: 100%;
                display: flex;
                align-items: center;
                line-height: 28px;
                padding: 10px 0;
                border-bottom: 1px solid rgba(232, 232, 232, 1);
                &:active {
                    background: rgba(0, 0, 0, 0.04);
                }
                &:first-child {
                    border-bottom: 0;
                    img {
                        width: 38px;
                        height: 38px;
                        border-radius: 50%;
                        margin-right: 8px;
                    }
                    span {
                        font-weight: bold;
                        color: rgba(51, 51, 51, 1);
                        font-size: 18px;
                    }
                }
                i {
                    font-size: 16px;
                    color: rgba(102, 102, 102, 1);
                    margin: 0 8px;
                }
                span {
                    flex: 1;
                    font-size: 16px;
                    color: rgba(51, 51, 51, 1);
                }
            }
        }
    }
    .head_user_popup_exit {
        width: 100%;
        left: 0;
        bottom: 0;
        line-height: 44px;
        text-align: center;
        font-size: 16px;
        color: rgba(51, 51, 51, 1);
        position: absolute;
        i {
            margin-right: 8px;
        }
    }
}
</style>
